module.exports = __webpack_public_path__ + "img/zhuanxiangfuwu-.21732689.png";